import React from 'react'
import HomeBanner from './home/HomeBanner'
import Opportunities from './home/Opportunities'
import MissionVision from './home/MissionVision'
import HomeAbout from './home/HomeAbout'
import HomeReviews from './home/HomeReviews'
import HomeGallery from './home/HomeGallery'
import HomeBlog from './home/HomeBlog'
import OurTeam from './home/OurTeam'
import HomeTopResult from './home/HomeTopResult'
import NewsAdvertisement from './home/NewsAdvertisement'
import Results2026 from './home/Results2026'
import WhyChooseUs from './home/WhyChooseUs'
import VideoGallery from './home/VideoGallery'

const Home = () => {
  return (
    <>

      <div style={{overflow:"hidden"}}>
        <HomeBanner />
        <HomeAbout />
        <MissionVision />
        <Results2026 />
        <VideoGallery />
        <WhyChooseUs />
        <OurTeam />
        <HomeReviews />
        <HomeGallery />
        <HomeBlog />
        <NewsAdvertisement />

        {/* <HomeTopResult /> */}
        <Opportunities />
      </div>





    </>
  )
}

export default Home